// /Frontend/hoppla-admin/src/components/ui/HopplaLogo.tsx

type HopplaLogoProps = {
  className?: string;
};

export default function HopplaLogo({
  className = '',
}: HopplaLogoProps): JSX.Element {
  return <span className={`hoppla-logo-wordmark ${className}`.trim()}>Hoppla</span>;
}
